import script from "./cottonBotManage.vue?vue&type=script&setup=true&lang=js"
export * from "./cottonBotManage.vue?vue&type=script&setup=true&lang=js"

import "./cottonBotManage.vue?vue&type=style&index=0&id=2c93fe09&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c93fe09"]])

export default __exports__